import { AssetScaleType } from "../../enums/SDKAssetScaleType";
import { DocsEntityHeader } from "./SDKDocsEntityHeader";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocsEntityConfiguration {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model, title) {
        this.header = new DocsEntityHeader(model.header);
        this.showSidebar = model.showSidebar;
        this.title = title;
        this.isHidden = model.isHidden;
        this.isPrivate = model.isPrivate;
    }
    /** Constructs representation that can be used to write full object to remote */
    toRemote() {
        const model = {
            showSidebar: this.showSidebar,
            header: this.header.toRemote(),
            isHidden: this.isHidden,
            isPrivate: this.isPrivate,
        };
        return model;
    }
    clone() {
        return new DocsEntityConfiguration(this.toRemote(), this.title);
    }
    static default() {
        const model = {
            showSidebar: true,
            isHidden: false,
            isPrivate: false,
            header: {
                description: "",
                alignment: "Left",
                backgroundImageScaleType: AssetScaleType.aspectFill,
                showBackgroundOverlay: false,
                showCoverText: false,
                minHeight: null,
            },
        };
        return new DocsEntityConfiguration(model, "");
    }
}
